module.exports = __webpack_public_path__ + "static/media/logo-hydeout-prelude.44de6942.png";